<template>
  <div class="kitchen-display">
    <header>
      <div class="row w-100 ml-0">
        <div class="col-md-2">
          <div class="d-flex justify-content-between">
            <img src="@/assets/img/icons/snack.svg" width="45" height="45" />
            <div class="ml-2">
              <b-dropdown
                v-if="isPosOperator || isFnbOperator"
                right
                class="pos-header-dropdown kitchen-header-dropdown w-100"
                variant="pos-dropdown"
              >
                <template v-slot:button-content>
                  <span class="custom-dropdownText">Kitchen Display</span>
                </template>
                <template>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item
                    class="activeDisplay"
                    @click="onSwitchKitchenDisplay('Kitchen Display')"
                  >
                    Kitchen Display
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="onSwitchKitchenDisplay('Kitchen Pickup')"
                  >
                    Kitchen Display Delivery
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                </template>
              </b-dropdown>
              <div v-else class="d-flex align-items-center">
                <div>
                  Kitchen Display 
                </div>
                <span v-if="is_premier_kitchen_user == 'Y'" class="icon-star icon-premium-fill"></span>
              </div>
              <small>{{ currentDate }}</small>
            </div>
          </div>
        </div>
        <div class="col-md-7 align-self-center">
          <ul class="nav nav-pills nav-fill">
            <li
              class="nav-item"
              v-for="(tab, tabIndex) in TabsArray"
              :key="tabIndex"
              v-if="checkTabToShow(tab)"
              @click="ChangeTab(tab.status)"
              :style="
                SelectedTab == tab.status
                  ? 'border: 4px solid' + currentTab.colorCode + '!important;'
                  : ''
              "
            >
              <a
                class="nav-link"
                :class="{ active: SelectedTab == tab.status }"
                :href="tabUrl"
                >{{ tab.tabName }} {{ " " }} ({{ tab.totalCount }})</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2 d-flex align-items-center p-0">
          <input
            class="form-control mr-sm-2 br-20"
            id="searchclearbox"
            name="searchclearbox"
            type="search"
            v-model="search"
            v-on:search="onSearch"
            v-debounce:400="onSearch"
            placeholder="Search"
            aria-label="Search"
          />
          <VkeyboardFloat
                :ID="'searchclearbox'"
                :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showV1Keyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
              />
              <Vkeyboard
                :inputName="'searchclearbox'"
                :showOrHide="keyboardsVisible.showV1Keyboard"
                :initialValue="search"
                @onChangeEvent="() => {}"
                @onKeyEnter="onSearch"
                @changeKeyboardInput="search = $event"
                @onClickClose="() => {
                  keyboardsVisible.showV1Keyboard = false;
                }"
              />
        </div>
        <div
          v-if="isPosOperator || isFnbOperator"
          class="col-md-1 d-flex align-self-center text-center"
        >
        <div class="reloadBtn d-flex align-items-center" @click="reloadOrders()">
            <span class="reload-icon"></span>
          </div>
          <router-link @click.native.prevent="onClickBackToPos()" to>
            <img
              src="@/assets/img/icons/close-white.svg"
              width="20"
              alt
              class="closeBtn"
            />
            <div class="text-white">Close</div>
          </router-link>
        </div>
        <div class="col-md-1 d-flex align-self-center text-center" v-else>
          <div class="reloadBtn d-flex align-items-center" @click="reloadOrders()">
            <span class="reload-icon"></span>
          </div>
          <router-link @click.native.prevent="onLogout()" to>
            <img src="@/assets/img/icons/logout.svg" width="20" height="20" />
            <div class="text-white">Logout</div>
          </router-link>
        </div>
      </div>
    </header>

    <div class="main-section">
      <div class="d-flex mx-4" :style="'flex-wrap: wrap'">
        <template v-if="OrdersList && OrdersList.length > 0 && checkOrderCount">
          <div
            v-for="(orders, ordersIndex) in OrdersList"
            :key="ordersIndex"
            class="card mr-3 mb-4"
            style="width: 18rem; background-color: #c7c7c742"
            @dblclick="zoomOrder(orders)"
            v-if="orders.OtherItems.length > 0"
          >
            <div
              class="card-header"
              :style="
                'color:white;background-color:' +
                orders.colorCode +
                '!important;'
              "
            >
              ORDER NO. {{ orders.order_code }}
              <span v-if="(SelectedTab != 'Cancel' && SelectedTab != 'Delivered') && (isPosOperator || isFnbOperator)">
                <button
                class="cancelOrderBtn"
                @click="OnCancelOrder(orders)"
              >
                ✖
              </button>
              </span>
            </div>
            <ul class="list-group list-group-flush" style="max-height: 435px; overflow-y: auto;">
              <li
                class="list-group-item item-list-card"
                v-for="(moreItems, moreItemsIndex) in orders.OtherItems"
                :key="moreItemsIndex"
              >
                {{ moreItems.fat_quantity }}X-{{ moreItems.item_name }}
              </li>
            </ul>
            <div class="btngrp mt-auto px-2">
              <div
                class="d-flex justify-content-center mt-4"
                v-if="['Pending'].includes(SelectedTab)"
              >
                <div
                  :class="
                    ['Processing'].includes(orders.fat_status) ? 'disBtn' : ''
                  "
                  class="btn btn-primary actionBtn mr-2"
                  :style="
                    ['Processing'].includes(orders.fat_status)
                      ? 'background-color: #dda150 !important'
                      : ['Pending'].includes(orders.fat_status)
                      ? 'background-color: #3ea205 !important'
                      : ''
                  "
                  @click="OnFinalSubmit(orders.ft_id, 'Processing', orders)"
                >
                  {{
                    ["Processing"].includes(orders.fat_status)
                      ? "Processing"
                      : "Start"
                  }}
                </div>
                <div
                  class="btn btn-primary actionBtn"
                  :style="
                    'background-color:' + currentTab.colorCode + '!important;'
                  "
                  @click="OnFinalSubmit(orders.ft_id, 'Complete')"
                >
                  {{ "Ready" }}
                </div>
              </div>
              <div class="d-flex justify-content-center mt-4" v-if="['Processing'].includes(SelectedTab)">
                <div
                  class="btn btn-primary actionBtn w95p"
                  :style="
                    'background-color:' + currentTab.colorCode + '!important;'
                  "
                  @click="OnFinalSubmit(orders.ft_id, 'Complete')"
                >
                  {{ "Ready" }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center col-12 pt-5 mt-5">
            <div class="pt-5">
              <img
                src="@/assets/img/icons/pos-fnb-no-itmes.svg"
                height="75"
                width="75"
              />
              <div class="mt-3 font-weight-semi-bold">NO RECORD FOUND</div>
            </div>
          </div>
        </template>
      </div>
      <div
        class="d-flex justify-content-center mt-3"
        v-if="
          OrdersList.length > 0 &&
          OrdersList.length < rows &&
          OrdersList.length >= perPage
        "
      >
        <div
          class="btn loadMoreBtn"
          :style="'background-color:' + currentTab.colorCode + '!important;'"
          @click="loadMore"
        >
          Load More
        </div>
      </div>
    </div>
    <b-modal id="info" ref="info" title="Info" hide-footer hide-header>
      <div class="info-list">
        <div class="info-title text-center font-weight-bold">
          <img src="@/assets/img/icons/info.svg" width="20" height="20" />
          Information
        </div>
        <hr />
        <ul>
          <li>
            All the un processed orders will be displayed in the
            <span class="font-weight-bold">LIVE</span> Tab
          </li>
          <li>
            All the orders which are in progress but not yet delivered will be
            displayed in the
            <span class="font-weight-bold">In Progress</span> Tab
          </li>
          <li>
            The orders which are delivered to the customers will be displayed in
            <span class="font-weight-bold">DELIVERED</span> Tab
          </li>
          <li>
            The orders which are cancelled will be displayed in
            <span class="font-weight-bold">CANCELLED</span> Tab
          </li>
          <li>
            The orders placed from other sources will be displayed in
            <span class="font-weight-bold">ONLINE</span> Tab
          </li>
        </ul>
      </div>
    </b-modal>
    <b-modal
      id="cancelOrder"
      title="Confirmation"
      hide-footer
      no-close-on-backdrop
      @close="onCancel"
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-4">{{ `Do You Want to Cancel This Order` }}</p>

        <button class="btn-outline-blue" @click.prevent.stop="onCancel">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="updateOrderStatus"
        >
          Proceed
        </button>
      </div>
    </b-modal>
    <b-modal
      id="zoomOrder"
      ref="zoomOrder"
      title="zoomOrder"
      hide-footer
      hide-header
      no-fade
      centered
    >
      <div class="customer-order-reciept">
        <div
          class="co-header"
          :style="'background-color:' + currentTab.colorCode + '!important;'"
        >
          ORDER NO. {{ selectedOrder.order_code }}
        </div>
        <div class="co-details maxHeight_co_footer">
          <div class="co-menu mb-4">
            <div class="co-menu-heading d-flex">
              <div class="text-center">Qty</div>
              <div>Items</div>
            </div>
            <div
              v-for="(moreItems, moreItemsIndex) in selectedOrder.OtherItems"
              :key="moreItemsIndex"
              class="menu-item"
            >
              <div class="text-center">{{ moreItems.fat_quantity }}</div>
              <div>{{ moreItems.item_name }}</div>
              <!-- <div class="text-center">X</div> -->
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center"
          v-if="['Pending'].includes(SelectedTab)"
        >
          <div
            :class="
              ['Processing'].includes(selectedOrder.fat_status) ? 'disBtn' : ''
            "
            class="btn btn-primary actionBtn mr-2"
            :style="
              ['Processing'].includes(selectedOrder.fat_status)
                ? 'background-color: #dda150 !important'
                : ['Pending'].includes(selectedOrder.fat_status)
                ? 'background-color: #3ea205 !important'
                : ''
            "
            @click="
              OnFinalSubmit(selectedOrder.ft_id, 'Processing', selectedOrder)
            "
          >
            {{
              ["Processing"].includes(selectedOrder.fat_status)
                ? "Processing"
                : "Start"
            }}
          </div>
          <div
            class="btn btn-primary actionBtn"
            :style="'background-color:' + currentTab.colorCode + '!important;'"
            @click="OnFinalSubmit(selectedOrder.ft_id, 'Complete')"
          >
            {{ "Ready" }}
          </div>
        </div>
        <div class="d-flex" v-if="['Processing'].includes(SelectedTab)">
          <div
            class="co-footer"
            :style="'background-color:' + currentTab.colorCode + '!important;'"
            @click="OnFinalSubmit(selectedOrder.ft_id, 'Complete')"
          >
            {{ "Ready" }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import KitchenService from "@/services/KitchenService";
import UserService from "@/services/UserService";
import moment from "moment";
import { backendSocket } from "@/main.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import _ from 'lodash'

export default {
  components: {
    VkeyboardFloat,
    Vkeyboard,
  },
  data() {
    return {
      keyboardsVisible: {
        showV1Keyboard: false,
      },
      apiLoading: false,
      currentDate: moment().format("Do MMMM YYYY hh:mm a"),
      OrdersList: [],
      OrdersCopy: [],
      SelectedTab: "Pending",
      TotalOrders: 0,
      PendingOrders: 0,
      DeliveredOrders: 0,
      search: null,
      cinema_id: null,
      interval: "",
      reloadOrder: "",
      isPosOperator: false,
      isFnbOperator: false,
      tabUrl: "",
      perPage: 15,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedCancelOrder: "",
      TabsArray: [],
      currentTab: "",
      fetchTime: 60, //sec
      is_premier_kitchen_user: 'N',
      selectedOrder: {
        ft_id: null,
        fat_status: null,
        order_code: null,
        OtherItems: [],
        OtherItems: [],
      },
    };
  },
  computed: {
    // RealTime() {
    //   return this.currentDate;
    // }
    checkOrderCount() {
      let count = 0;
      if(this.OrdersList && this.OrdersList.length > 0) {
        this.OrdersList.forEach((c) => {
          if(c.OtherItems.length > 0) {
            count++;
          }
        })
      }

      if(count > 0) {
        return true
      } else {
        return false;
      }
    },
    ...mapGetters([
      "DIRECT_DELIVER_READY_TO_SERVE_ITEMS",
    ]),
    
  },
  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.is_premier_kitchen_user = this.secureStore.get("USINFO").is_premier_kitchen_user;
    if (this.$route.query.isPosOperator) {
      this.isPosOperator = true;
      this.isFnbOperator = false;
      this.tabUrl = "/#/kitchen-sales?isPosOperator=true";
    } else if (this.$route.query.isFnbOperator) {
      this.isPosOperator = false;
      this.isFnbOperator = true;
      this.tabUrl = "/#/kitchen-sales?isFnbOperator=true";
    } else {
      this.isPosOperator = false;
      this.isFnbOperator = false;
      this.tabUrl = "/#/kitchen-sales";
    }
    this.GetOrders();
  },
  watch: {},
  mounted: function () {
    backendSocket.on("get_kitchen-orders", (data) => {
      console.log("get_kitchen-orders socket", data);
      this.apiLoading = false;
      if (data.status) {
        if (data.Records && data.Records.length > 0) {
          // this.OrdersList = this.OrdersList.concat(data.Records);
          console.log('data.Records TEMPARRAY', _.cloneDeep(data.Records));
          this.OrdersList = data.Records;
          this.OrdersList = [
            ...new Map(
              this.OrdersList.map((item) => [item["order_code"], item])
            ).values(),
          ];
          this.OrdersList.forEach((x) => {
            x['OtherItems'] = this.getOnlyKitchenItems(x['OtherItems']);
          })
          this.TabsArray = data.TotalArray;
          this.currentTab = data.currentTab[0];
          this.rows = data.currentTab[0].totalCount;
          this.currentDate = data.currentTimeFormat;
          // this.ChangeTab("Pending");
        } else {
          this.$toasted.show(data.message);
        }
      } else {
        if (
          data.hasOwnProperty("TotalArray") &&
          data.hasOwnProperty("currentTab") &&
          data.currentTimeFormat
        ) {
          this.TabsArray = data.TotalArray;
          this.currentTab = data.currentTab[0];
          this.rows = data.currentTab[0].totalCount;
          this.currentDate = data.currentTimeFormat;
        }
        // this.ChangeTab("Pending");
        this.$toasted.show(data.message);
      }
    });

    this.interval = setInterval(() => {
      this.currentDate = moment().format("Do MMMM YYYY hh:mm a");
      this.GetOrders();
    }, this.fetchTime * 1000);
  },
  beforeDestroy() {
    if (backendSocket) {
      backendSocket.off("get_kitchen-orders");
      backendSocket.off("fetch-kitchen-orders");
    }
    clearInterval(this.interval);
  },
  methods: {
    moment,
    getOnlyKitchenItems(ItemArray) {
      let tempItemArray = ItemArray;
      if(this.DIRECT_DELIVER_READY_TO_SERVE_ITEMS == 'Y') {
        tempItemArray = ItemArray.filter((x) => x.is_ready_to_serve_item == 'N')
      }
      console.log('this.secureStore.get("USINFO")', this.secureStore.get("USINFO"));
      if(this.secureStore.get("USINFO").is_premier_kitchen_user== 'Y' || this.is_premier_kitchen_user == 'Y') {
        tempItemArray = tempItemArray.filter((x) => x.is_premier_item == 'Y')
      } else {
        tempItemArray = tempItemArray.filter((x) => x.is_premier_item == 'N')
      }
      return tempItemArray
    },
    reloadOrders() {
      let loader = this.$loading.show();
      this.currentPage = 1;
      this.GetOrders();
      setTimeout(() => {
        loader.hide()
      }, 500);
    },
    onSwitchKitchenDisplay(routeName) {
      this.$router.push({
        name: routeName,
        query: {
          isPosOperator: this.isPosOperator,
          isFnbOperator: this.isFnbOperator,
        },
      });
    },
    zoomOrder(order) {
      this.selectedOrder = _.cloneDeep(order);
      this.$bvModal.show("zoomOrder");
    },
    checkTabToShow(tab) {
      let status = true;
      if(tab.showTab || this.isPosOperator || this.isFnbOperator) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    onSearch() {
      this.OrdersList = [];
      this.GetOrders();
    },
    onCancel() {
      this.selectedCancelOrder = "";
      this.$bvModal.hide("cancelOrder");
    },
    OnCancelOrder(order) {
      this.selectedCancelOrder = order;
      this.$bvModal.show("cancelOrder");
    },
    updateOrderStatus() {
      this.OnFinalSubmit(this.selectedCancelOrder.ft_id, "Cancel");
      this.$bvModal.hide("cancelOrder");
    },
    OrderTimer(orderTime) {
      var startDate = new Date(orderTime);
      var endDate = new Date();
      var diff = endDate.getTime() - startDate.getTime();
      var hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * (1000 * 60 * 60);
      var minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * (1000 * 60);
      var seconds = Math.floor(diff / 1000);

      if (hours < 0) hours = hours + 24;

      return (
        (hours <= 9 ? "0" : "") +
        hours +
        ":" +
        (minutes <= 9 ? "0" : "") +
        minutes +
        ":" +
        (seconds <= 9 ? "0" : "") +
        seconds
      );
    },
    GetOrders: function () {
      let payload = {
        search: this.search,
        cinema_id: this.cinema_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        status: this.SelectedTab,
        displayType: 1,
        is_premier_kitchen_user: this.is_premier_kitchen_user || this.secureStore.get("USINFO").is_premier_kitchen_user || 'N'
      };
      if (backendSocket && backendSocket.connected) {
        console.log("Fetching from kitchen Display");
        this.apiLoading = true;
        backendSocket.emit("fetch-kitchen-orders", payload);
      } else {
        let loader = this.$loading.show();
        this.apiLoading = true;
        KitchenService.GetAllOrders(payload)
          .then((response) => {
            const { data } = response;
            loader.hide();

            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                // this.OrdersList = this.OrdersList.concat(data.Records);
                this.OrdersList = data.Records;
                this.OrdersList = [
                  ...new Map(
                    this.OrdersList.map((item) => [item["order_code"], item])
                  ).values(),
                ];
                this.OrdersList.forEach((x) => {
                  x['OtherItems'] = this.getOnlyKitchenItems(x['OtherItems']);
                })
                this.TabsArray = data.TotalArray;
                this.currentTab = data.currentTab[0];
                this.rows = data.currentTab[0].totalCount;
                this.currentDate = data.currentTimeFormat;
                // this.ChangeTab("Pending");
              } else {
                this.$toasted.show(data.message);
              }
            } else {
              if (
                data.hasOwnProperty("TotalArray") &&
                data.hasOwnProperty("currentTab") &&
                data.currentTimeFormat
              ) {
                this.TabsArray = data.TotalArray;
                this.currentTab = data.currentTab[0];
                this.rows = data.currentTab[0].totalCount;
                this.currentDate = data.currentTimeFormat;
              }
              // this.ChangeTab("Pending");
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            this.apiLoading = false;
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    ChangeTab: function (type) {
      this.TotalOrders = 0;
      this.PendingOrders = 0;
      this.DeliveredOrders = 0;
      this.currentPage = 1;
      this.SelectedTab = type;
      this.OrdersList = [];
      this.TotalOrders = this.OrdersList.length;
      this.GetOrders();
    },
    loadMore() {
      this.currentPage += 1;
      this.GetOrders();
    },

    OnFinalSubmit: function (ID, type, order = null) {
      let payload = {
        ft_id: ID,
        fnb_order_status: type,
      };
      this.$bvModal.hide("zoomOrder");
      KitchenService.UpdateOrders(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (type == "Processing") {
              if (order) {
                order["fat_status"] = type;
              }
            } else {
              this.OrdersList = [];
            }
            this.currentPage = 1;
            this.GetOrders();
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onClickBackToPos() {
      if (this.isFnbOperator) {
        this.$router.push({ path: "/pos-fnb" });
      } else {
        this.$router.push({ path: "/pos-booking" });
      }
    },

    onLogout: function () {
      UserService.removeToken()
        .then((res) => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
          } else {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$router.push({ path: "/pos-login" });
          this.$toasted.show("Token not removed");
        });
    },
  },
};
</script>

<style>
.kitchen-display {
  background-color: #ffffff;
  margin-bottom: 30px;
}

.kitchen-display header {
  padding: 10px;
  color: #ffffff;
  background-color: #3f4343;
}

.kitchen-display footer {
  padding: 15px 5px;
  position: fixed;
  color: #ffffff;
  background-color: #3f4343;
  width: 100%;
  bottom: 0px;
}

.kitchen-display .main-section {
  padding: 10px;
}

.kitchen-display header .nav-pills .nav-item {
  border: 1px solid;
  border-radius: 5px;
  /* width: 70px !important; */
  margin: 0px 5px;
}

.kitchen-display header .nav-pills .nav-link.active {
  color: #3f4343;
  background-color: #ffffff;
}

.kitchen-display header .nav-pills .nav-link {
  color: #ffffff;
}

.customer-order-reciept {
  width: 100%;
  border-radius: 10px;
  background: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.customer-order-reciept .co-header {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  background-color: #3876d2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.customer-order-reciept .co-details .co-menu {
  /* height: 130px;
  overflow-y: auto; */
  /* max-height: 130px; */
  min-height: 125px;
  overflow-y: auto;
}

.customer-order-reciept .co-details .co-menu .menu-item {
  display: flex;
  border-bottom: 1px solid lavender;
  font-size: 18px;
  padding: 2px 10px;
  font-weight: bold;
}

.customer-order-reciept .co-details .co-menu .co-menu-heading {
  display: flex;
  border-bottom: 2px solid lavender;
  font-size: 12px;
  padding: 05px 10px 05px 10px;
  /* font-weight: bold; */
}

.customer-order-reciept .co-details {
  font-size: 13px;
  /* padding-top: 10px; */
  /* padding-bottom: 10px; */
  /* padding-left: 5px; */
  /* padding-right: 5px; */
}

.customer-order-reciept .co-details .co-menu .co-menu-heading div:nth-child(1) {
  width: 14%;
}

.customer-order-reciept .co-details .co-menu .co-menu-heading div:nth-child(2) {
  width: 80%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(1) {
  width: 14%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(2) {
  width: 80%;
}

.customer-order-reciept .co-details .co-menu div div:nth-child(3) {
  /* width: 20%; */
}

.customer-order-reciept .co-details .co-main-details {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 05px 0 05px;
}

.customer-order-reciept .co-details .co-main-details .fifty-pc {
  width: 50%;
  display: flex;
}

.maxHeight_co_footer {
  max-height: 400px;
  overflow-y: auto;
}

.customer-order-reciept
  .co-details
  .co-main-details
  .fifty-pc
  div:nth-child(1) {
  /* width: 62%; */
}

.customer-order-reciept
  .co-details
  .co-main-details
  .fifty-pc
  div:nth-child(2) {
  /* width: 40%; */
  /* padding-left: 05px; */
}

.customer-order-reciept .co-footer {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  background-color: #25bf48d9;
  width: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.customer-order-reciept .co-footer-dual {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

.customer-order-reciept .co-footer-dual:first-child {
  background-color: #25bf48d9;
  width: 50%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 0px;
}

.customer-order-reciept .co-footer-dual:last-child {
  background-color: #13a6ad;
  width: 50%;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 10px;
}

.customer-order-reciept .co-footer:hover,
.customer-order-reciept .co-footer-dual:hover {
  background-color: #5d8fd8;
}

.co-total-price {
  margin-top: 0.25rem !important;
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-top: 2px solid #dee2e6 !important;
  padding-bottom: 10px;
  background-color: whitesmoke;
  font-size: 13px;
  padding: 0.25rem 05px 05px 05px;
}

/* .create-journey-container {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  display: flex;
  z-index: 9999;
  position: fixed;
  min-height: 100vh;
  overflow: hidden;
  padding-top: 65px;
  background-color: #fff;
}

.create-journey-header {
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  padding: 15px;
  position: fixed;
  width: calc(100% -275px);
  background-color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.journey-left-sidebar {
  width: 275px;
  height: calc(100vh - 65px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 15px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.journey-center-content {
  width: calc(100% - 275px);
}

.journey-right-sidebar {
  top: 67.5px;
  width: 340px;
  right: -340px;
  z-index: 99999;
  position: fixed;
  overflow-y: auto;
  padding: 10px 15px;
  overflow-x: hidden;
  background-color: #fff;
  height: calc(100vh - 65px);
  transition: 0.2s ease-in-out;
  border-left: 1px solid #d3d3d3;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.journey-right-sidebar.is-active {
  right: 0;
}

.journey-right-sidebar .input-material {
  height: 31px;
  min-height: 31px;
}

.journey-right-sidebar .input-material input {
  min-height: 31px;
  border-radius: 5px;
}

.journey-right-sidebar .add-datepicker input::placeholder {
  color: var(--dark);
}

.journey-right-sidebar .vdp-datepicker__calendar {
  top: 35px;
}
.btn-element-toggle {
  width: 100%;
  color: #fff;
  padding: 10px 10px;
  font-size: 14px;
  border: none;
  text-align: left;
  border-radius: 3px;
  position: relative;
  background-color: GREY;
}

.btn-element-toggle::after {
  content: "";
  width: 7.5px;
  right: 15px;
  height: 7.5px;
  display: block;
  position: absolute;
  top: calc(50% - 6px);
  transition: 0.2s ease;
  border-top: 2px solid #fff;
  border-left: 2px solid #fff;
  transform: rotate(225deg);
}

.btn-element-toggle:not(.collapsed):after {
  top: calc(50% - 2.5px);
  transform: rotate(45deg);
}

.element-box {
  cursor: move;
  font-size: 12px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 10px 5px;
  text-align: center;
  margin-bottom: 15px;
  transition: 0.2s ease;
  width: calc(50% - 10px);
  border: 1px solid #d3d3d3;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.element-box:nth-child(even) {
  margin-left: 20px;
}

.element-box:hover {
  color: var(--blue);
  background-color: #fff;
  border-color: var(--blue);
  transform: scale(1.075);
}
.journey-center-content .flowchart-node .node-delete {
  font-size: 16px;
  line-height: 1.2;
  height: 20px;
  right: -7.5px;
  top: -7.5px;
  width: 20px;
  color: var(--danger);
  transition: 0.2s ease;
  border: 1px solid var(--danger);
}

.journey-center-content .flowchart-node.selected {
  box-shadow: 0 0 0 2px var(--blue);
}

.journey-center-content .flowchart-node .node-type {
  background-color: var(--blue) !important;
}
.journey-center-content .flowchart-node .node-delete:hover {
  color: #fff;
  background-color: var(--danger);
} */
.info-list ul li {
  padding-bottom: 10px;
}

.cancelOrderBtn {
  position: absolute;
  top: 8px;
  right: 5px;
  width: auto;
  border: none;
  height: auto;
  font-size: 15px;
  color: #ffffff;
  font-weight: bold;
  background-color: transparent;
}

.loadMoreBtn {
  padding: 10px;
  border: none;
  border-radius: 20px;
  width: 135px;
  color: white;
  background-color: #3876d2;
}

.actionBtn {
  width: 165px;
  border: none !important;
  margin-bottom: 15px;
}

.disBtn {
  opacity: 0.7;
  pointer-events: none;
}

.br-20 {
  border-radius: 20px;
}

.custom-dropdownText,
.kitchen-header-dropdown .dropdown-toggle::after {
  color: white;
  font-size: 14px;
}

.activeDisplay {
  background: lightgray;
}
.item-list-card {
  padding: 0.35rem 1.25rem !important;
  font-weight: bold !important;
  font-size: 16px;
}
.w95p {
  width: 95%!important;
}

#zoomOrder___BV_modal_content_ {
  background: transparent !important;
  border: none !important;
  width: 120%;
  zoom: 1.3;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/KitchenDisplayComponents/kitchenDisplay.vue